<template>
  <div class="fff">
    <div class="page_title">{{ $t("Select the Device") }}</div>
    <div class="list">
      <div
        class="page_bo_li"
        v-for="(item, index) in equipmentList"
        :key="index"
        @click="onSelectequipment(item, index)"
      >
        <img
          :src="
            equipmentIndex == index
              ? require('@/assets/img/qdui.png')
              : require('@/assets/img/qnodui.png')
          "
          alt=""
          class="system_logo"
        />
        {{ item }}
      </div>
    </div>
    <div class="twoButton">
      <div class="BackButton" @click="onBack">
        {{ $t("selectTheDevice.back") }}
      </div>
      <div class="loginButton" @click="onSelectDevice">
        {{ $t("selectTheDevice.continue") }}
      </div>
    </div>
  </div>
</template>

<script>
import { updateIosDeviceName, appleVerficationCodeNewV2 } from "@/api/user";
export default {
  data() {
    return {
      isshow: 0,
      msg: "",
      code: "",
      equipmentList: [],
      equipmentIndex: -1,
      equipmentName: "",
    };
  },
  mounted() {
    this.code = this.$route.params.code;
    console.log(this.$route.params, "this.code");
    this.getEquipment();
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    onSelectequipment(item, index) {
      this.equipmentIndex = index;
      this.equipmentName = item;
    },
    onSelectDevice() {
      if (this.equipmentName) {
        this.updateDevice();
      } else {
        this.$message.error(this.$t("selectTheDevice.msg"));
      }
    },
    // 获取设备列表
    getEquipment() {
      if (this.code) {
        // 有 code → 走 Verification.vue 过来的原有接口
        let key = {
          equipment_id: localStorage.getItem("systemId"),
          code: this.code,
        };
        appleVerficationCodeNewV2(key).then((adj) => {
          if (adj.code === 11) {
            console.log(adj.data, "adj.data");
            this.equipmentList = adj.data;
          }
        });
      } else {
        // 无 code → 走 Enter.vue 过来的缓存
        const cached = localStorage.getItem("cachedDeviceList");
        if (cached) {
          try {
            this.equipmentList = JSON.parse(cached);
          } catch (e) {
            console.error("parse cachedDeviceList failed", e);
          }
        }
      }
    },
    // 更新设备
    updateDevice() {
      let key = {
        equipment_id: localStorage.getItem("systemId"),
        name: this.equipmentName,
      };
      updateIosDeviceName(key).then((adj) => {
        if (adj.code === 1) {
          // 绑定成功，清缓存
          localStorage.removeItem("cachedDeviceList");
          this.$router.push({ name: "ok" });
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.list {
  height: calc(100vh - 260px);
  overflow-y: auto;
}
.page_bo_li {
  margin-bottom: 20px;
  position: relative;
  padding: 25px 0;
  line-height: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
}
.system_logo {
  float: left;
  width: 20px;
  margin: 5px 15px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectTheDevice.vue